<div class="medium-container pt-4">
  <section class="pt-5 pb-5">
    <p class="call-out-text mt-2 mb-5 text-left">RUBBL MANAGED SERVICES</p>
    <div class="row">
      <div class="col-md-6 col-lg-3" *ngFor="let marketingCard of marketingCards">
        <common-marketing-card [marketingCard]="marketingCard"></common-marketing-card>
      </div>
    </div>
  </section>
</div>
